import React, { forwardRef } from "react";
import { LocationInventory } from "../../../features/FloorManager/typings/location-inventory";
import { useTranslation } from "react-i18next";
import { Box, Button, CardContent, Grid2, Typography } from "@mui/material";
import { LocationStyledContainer } from "../LocationStyledContainer/LocationStyledContainer.component";

type P = {
  location: LocationInventory;
  onClickEnable?: () => void;
};

export const LocationNonPreferredCard: React.FC<P> = forwardRef<HTMLDivElement, P>(
  ({ location, onClickEnable }, ref) => {
    const { t } = useTranslation();

    return (
      <LocationStyledContainer
        picturePath={location.picturePath ?? "https://picsum.photos/190.webp"}
        isPreferred={false}
      >
        <Box sx={{ display: "flex", flexDirection: "column", width: "100%" }} ref={ref}>
          <CardContent sx={{ flex: "0 0 auto", p: "16px 16px 0 16px" }}>
            <Grid2 container data-testid="location-nonPreferred-card-content-grid">
              {/* this typography can be replaced by <ResizableTextComponent name={location.name} /> */}
              <Typography sx={{ opacity: 0.6 }} component="h5" variant="h5">
                {location.name}
              </Typography>
            </Grid2>
            <Typography sx={{ opacity: 0.6 }} variant="subtitle1" color="textSecondary">
              {location.address1} {location.address2}
            </Typography>
            {/* add location button */}
            {onClickEnable && (
              <Box
                sx={{
                  paddingTop: 1.5,
                  mb: "-8px",
                  display: "flex",
                  height: "100%",
                  placeSelf: "flex-end"
                }}
              >
                <Button
                  sx={{ height: "fit-content", placeSelf: "flex-end" }}
                  data-testid={"button-add-location"}
                  onClick={onClickEnable}
                >
                  {t("AddLocation")}
                </Button>
              </Box>
            )}
          </CardContent>
        </Box>
      </LocationStyledContainer>
    );
  }
);
